import { AfterViewInit, Component, HostBinding } from '@angular/core'
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { filter } from 'rxjs/operators'

const loadingStartEventTypes = [NavigationStart]
const loadingStopEventTypes = [NavigationEnd, NavigationCancel]

@UntilDestroy()
@Component({
    selector: 'mg-routing-loading-status',
    templateUrl: './routing-loading-status.component.html',
    styleUrls: ['./routing-loading-status.component.scss'],
})
export class RoutingLoadingStatusComponent implements AfterViewInit {
    @HostBinding('class._is_loading')
    loading: boolean = false

    constructor(private router: Router) {}

    ngAfterViewInit() {
        const routerEvents$ = this.router.events.pipe(untilDestroyed(this))

        routerEvents$
            .pipe(filter(event => loadingStartEventTypes.some(eventType => event instanceof eventType)))
            .subscribe(event => (this.loading = true))

        routerEvents$
            .pipe(filter(event => loadingStopEventTypes.some(eventType => event instanceof eventType)))
            .subscribe(event => (this.loading = false))
    }
}
